import { CommonLayoutProps } from '@/types/other';
import Layout from './layout';

function Layout404({
  children,
  windowWidthSv = null,
  ...otherProps
}: CommonLayoutProps) {
  return (
    <Layout {...otherProps} windowWidthSv={windowWidthSv}>
      {children}
    </Layout>
  );
}

export default Layout404;
